var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99875 11.6666C11.8371 11.6666 13.3321 10.1716 13.3321 8.33329C13.3321 6.49496 11.8371 4.99996 9.99875 4.99996C8.16042 4.99996 6.66542 6.49496 6.66542 8.33329C6.66542 10.1716 8.16042 11.6666 9.99875 11.6666ZM9.99875 6.66663C10.9179 6.66663 11.6654 7.41413 11.6654 8.33329C11.6654 9.25246 10.9179 9.99996 9.99875 9.99996C9.07958 9.99996 8.33208 9.25246 8.33208 8.33329C8.33208 7.41413 9.07958 6.66663 9.99875 6.66663Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.51544 18.1783C9.65648 18.279 9.82546 18.3332 9.99877 18.3332C10.1721 18.3332 10.3411 18.279 10.4821 18.1783C10.7354 17.9991 16.6896 13.7 16.6654 8.33329C16.6654 4.65746 13.6746 1.66663 9.99877 1.66663C6.32294 1.66663 3.3321 4.65746 3.3321 8.32913C3.30794 13.7 9.2621 17.9991 9.51544 18.1783ZM9.99877 3.33329C12.7563 3.33329 14.9988 5.57579 14.9988 8.33746C15.0163 12.0358 11.3421 15.3566 9.99877 16.4458C8.65627 15.3558 4.98127 12.0341 4.99877 8.33329C4.99877 5.57579 7.24127 3.33329 9.99877 3.33329Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMap);
export default __webpack_public_path__ + "static/media/bx-map.1e74223018099fc53ee7b9469c21ec78.svg";
export { ForwardRef as ReactComponent };